module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate10.6fa0d20.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate10.png
// module id = 745
// module chunks = 0